var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ResultError_instances, _ResultError_patchStackTrace, _a;
import { captureStackTrace } from './fn/captureStackTrace.js';
const $ResultError = '__resultage::ResultError__';
export const isResultError = (error, code) => error?.[$ResultError] === true &&
    (code === undefined || error.code === code);
export class ResultError extends Error {
    static isResultError(error, code) {
        return isResultError(error, code);
    }
    constructor(result, code, message) {
        super(message);
        _ResultError_instances.add(this);
        this.name = 'ResultError';
        this[_a] = true;
        this.code = code;
        this.result = result;
    }
    static raise(result, code, message, fn) {
        const error = new ResultError(result, code, message);
        __classPrivateFieldGet(error, _ResultError_instances, "m", _ResultError_patchStackTrace).call(error, fn ?? ResultError.raise);
        throw error;
    }
}
_ResultError_instances = new WeakSet(), _a = $ResultError, _ResultError_patchStackTrace = function _ResultError_patchStackTrace(skipFn) {
    if (!this.stack)
        return;
    captureStackTrace(this, skipFn);
};
